import React, { memo, useCallback } from "react";
import { Slider } from "@mui/material";
import { AddOutfitContext } from "../../../contexts/Outfits/AddOutfit";
import { useState, useEffect, useContext } from "react";

const sliderColor = "#047857";

export const MemoizedSlider = memo(
	({
		dispatch = () => {},
		value = 0,
		min = 0,
		max = 69,
		label = "Slider Label",
		color = sliderColor,
		onChange = () => null,
	}) => {
		return (
			<>
				<label className="font-light text-xs lg:text-base">
					{label}
				</label>
				<Slider
					size="small"
					defaultValue={0}
					value={value}
					min={min}
					max={max}
					aria-label="Small"
					type="top"
					onChange={(e) => onChange(e)}
					sx={{
						color: color,
					}}
				/>
			</>
		);
	}
);

export const Sliders = () => {
	const [outfitState, dispatch] = useContext(AddOutfitContext);

	const position = outfitState.position;

	const minWidthValue = -90;
	const maxWidthValue = 90;

	const minCoordinateValue = -80;
	const maxCoordinateValue = 80;

	const dimensionObj = outfitState.outfitDimensionGrid[position];

	const changeSize = useCallback((event) => {
		dispatch({
			type: "change_dimension",
			value: event.target.value,
			dimension: "width_scale",
		});
	}, []);

	const changeSpacing = useCallback((event) => {
		dispatch({
			type: "change_dimension",
			value: event.target.value,
			dimension: "spacing_scale",
		});
	}, []);

	const changeTop = useCallback((event) => {
		dispatch({
			type: "change_dimension",
			value: event.target.value,
			dimension: "top_scale",
		});
	}, []);

	const changeLeft = useCallback((event) => {
		dispatch({
			type: "change_dimension",
			value: event.target.value,
			dimension: "left_scale",
		});
	}, []);

	const changeSplit = useCallback((event) => {
		dispatch({
			type: "change_dimension",
			dimension: "split_scale",
			value: event.target.value,
		});
	}, []);

	return (
		<div className="flex flex-col items-center w-full">
			<div className="flex flex-col w-2/3 lg:w-full">
				<MemoizedSlider
					value={
						dimensionObj !== undefined
							? dimensionObj.width_scale
							: 0
					}
					min={minWidthValue}
					max={maxWidthValue}
					dispatch={dispatch}
					onChange={changeSize}
					label="Size"
				/>
				<MemoizedSlider
					value={
						dimensionObj !== undefined
							? dimensionObj.spacing_scale
							: 0
					}
					min={0}
					max={100}
					dispatch={dispatch}
					color={"#1d4ed8"}
					onChange={changeSpacing}
					label="Spacing"
				/>
				<MemoizedSlider
					value={
						dimensionObj !== undefined ? dimensionObj.top_scale : 0
					}
					min={minCoordinateValue}
					max={maxCoordinateValue}
					dispatch={dispatch}
					color={"black"}
					onChange={changeTop}
					label="Top"
				/>
				<MemoizedSlider
					value={
						dimensionObj !== undefined ? dimensionObj.left_scale : 0
					}
					min={minCoordinateValue}
					max={maxCoordinateValue}
					dispatch={dispatch}
					color={"black"}
					onChange={changeLeft}
					label="Left"
				/>
				{position == 3 && (
					<MemoizedSlider
						value={
							dimensionObj !== undefined
								? dimensionObj.split_scale
								: 0
						}
						min={0}
						max={50}
						dispatch={dispatch}
						color={"black"}
						onChange={changeSplit}
						label="Split"
					/>
				)}
			</div>
		</div>
	);
};
